import React, { useRef, useState, useCallback, ReactNode } from 'react';
import PopNotification from './components/PopNotification';
import { PopNotificationRef } from './components/PopNotification/PopNotification.component';
import PopNotificationsContext, {
  Notification,
} from './PopNotifications.context';
import uniqid from 'uniqid';
// import { ERRORS_USER_FRIENDLY, ERROR_TYPES } from 'request-responses';

const PopNotifications: React.FC<{ children: ReactNode }> = (props) => {
  const { children } = props;

  const [notifications, setNotifications] = useState<
    Array<Notification & { notId: string }>
  >([]);
  const notificationsRef = useRef(new Set<PopNotificationRef>());

  const onNotificationClose = useCallback((n: Notification) => {
    n.onClose?.();
    setNotifications((old) => old.filter((not) => not !== n));
  }, []);

  const popInfo = useCallback((conf: Notification) => {
    Array.from(notificationsRef.current)
      .find((n) => n.open)
      ?.setOpen(false);
    setNotifications((old) => [...old, { ...conf, notId: uniqid() }]);
  }, []);

  const popError = useCallback(
    (content: string | ReactNode) => {
      popInfo({
        type: 'Error',
        content: content,
      });
    },
    [popInfo],
  );

  const popSuccess = useCallback(
    (content: string | ReactNode) => {
      popInfo({
        type: 'Success',
        content,
      });
    },
    [popInfo],
  );

  return (
    <PopNotificationsContext.Provider value={{ popInfo, popSuccess, popError }}>
      {notifications.map((n, ind) => (
        <PopNotification
          ref={(r) => r && notificationsRef.current.add(r)}
          key={n.notId}
          {...n}
          onClose={() => {
            notificationsRef.current.delete(
              Array.from(notificationsRef.current)[ind],
            );
            onNotificationClose?.(n);
          }}
        >
          {n.content}
        </PopNotification>
      ))}
      {children}
    </PopNotificationsContext.Provider>
  );
};

export default PopNotifications;
